import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetVersionEditInfo = () => {
  const [loading, setLoading] = useState(false);
  const [versionEditInfo, setVersionEditInfo] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const getVersionEditInfo = guid => {
    setLoading(true);
    setVersionEditInfo(null);

    axiosClient
      .get(`SettingSystem/Application/VersionControl/Update?GUID=${guid}`)
      .then(res => {
        if (res.status === 200) {
          setVersionEditInfo(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getVersionEditInfo, loading, versionEditInfo];
};

export default useGetVersionEditInfo;
